module.exports = __webpack_public_path__ + "static/media/Ring.d0bf8a61.mp3";